import ActionItemAdditionalInfo from "../../../../components/AssetManagement/Overview/ActionItems/ActionItemsAdditionalInfo/ActionItemAdditionalInfo"

const ActionItemAdditionalInfoScreen = () => {
  return (
    <>
      <ActionItemAdditionalInfo />
    </>
  )
}

export default ActionItemAdditionalInfoScreen